import { toActionId, toAgentId, useBatchGetActions, useGetAgent } from '@/hooks/api';
import { findActionIds, isNotConfiguredExport } from '@/utils';

export type UseGetNotConfiguredExportsOps = {
  agentId?: string | null;
};

export const useGetNotConfiguredExports = ({ agentId }: UseGetNotConfiguredExportsOps) => {
  const { data: agent } = useGetAgent(toAgentId(agentId));
  const actionIds = findActionIds(agent);
  const { data: actions } = useBatchGetActions(actionIds.map(toActionId));
  return { actions: actions?.filter(isNotConfiguredExport) };
};
